import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-by-keys-dropdown',
  templateUrl: './select-by-keys-dropdown.component.html',
  styleUrls: ['./select-by-keys-dropdown.component.scss']
})
export class SelectByKeysDropdownComponent {

  uniqueId: string = uuidv4();

  @Input()
  dataArray: any[] | undefined = [];

  @Input()
  selectedKey: any;

  @Input()
  selectedKeys: any[] = [];

  @Input()
  multiple: boolean = false;

  @Input()
  selectedText: string = "";

  @Input()
  noOptionsText: string = "No options";

  @Input()
  translateKey: string = "";

  @Input()
  placeholder: string = "";

  @Input()
  otherOption = false;

  @Input()
  loading: boolean = false

  @Input()
  error: boolean = false;

  @Input()
  showAbsolute: boolean = true;

  @Input() styles: { [key: string]: string } = {};

  @Output()
  optionEmitter = new EventEmitter();

  openDropdown = false;

  otherOptionKey: string = `Other_12345678`
  showOtherOptionInput: boolean = false;

  otherOptionText: string = ""

  private isFirstChange = true;

  constructor(private translateService: TranslateService) { }

  get selectedLabels(): string {
    if (this.multiple) {
      return this.selectedKeys.map(key => this.translateKey ? this.translateService.instant(this.translateKey + String(key)) : String(key)).join(', ');
    }
    return '';
  }

  isSelected(type: any): boolean {
    return (!this.multiple && this.selectedKey !== '' && this.selectedKey === type) || (this.multiple && this.selectedKeys.includes(type)) || (this.showOtherOptionInput && type == this.otherOptionKey);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setLoadingStatus()
    if (!changes['dataArray']?.firstChange) {
      this.setOtherOptionData();
    }
  }

  setLoadingStatus() {
    if (this.loading) {
      this.openDropdown = false;
      this.showOtherOptionInput = false;
    }
  }

  setOtherOptionData() {
    if (this.otherOption && this.dataArray && !this.loading) {
      if (!this.dataArray.includes(this.otherOptionKey)) {
        this.dataArray.push(this.otherOptionKey);
      }
      if (this.multiple) {
        if (!this.selectedKeys.some(key => !this.dataArray?.includes(key))) {
          this.showOtherOptionInput = false;
        } else {
          this.otherOptionText = this.selectedKeys.find(key => !this.dataArray?.includes(key)) || '';
          this.showOtherOptionInput = true;
        }
      } else {
        if (!this.dataArray.includes(this.selectedKey)) {
          this.otherOptionText = this.selectedKey
          this.showOtherOptionInput = true;
        } else {
          this.showOtherOptionInput = false;
        }
      }
    }
  }

  toggleDropdown() {
    if (!this.loading) {
      this.openDropdown = !this.openDropdown;
    }
  }

  selectOption(event: any, type: any) {
    event.stopPropagation();

    if (this.multiple) {
      if (this.otherOption && type == this.otherOptionKey) {
        this.showOtherOptionInput = true;
        if (!this.selectedKeys.includes(this.otherOptionText)) {
          this.selectedKeys.push(this.otherOptionText);
        }
        this.optionEmitter.emit(this.selectedKeys);
      } else {
        this.showOtherOptionInput = false;
        const index = this.selectedKeys.indexOf(type);
        if (index > -1) {
          this.selectedKeys.splice(index, 1);
        } else {
          this.selectedKeys.push(type);
        }
        this.optionEmitter.emit(this.selectedKeys);
      }
    } else {
      if (this.otherOption && type == this.otherOptionKey) {
        this.showOtherOptionInput = true;
        this.optionEmitter.emit(this.otherOptionText)
      } else {
        this.showOtherOptionInput = false;
        this.optionEmitter.emit(type)
      }
      this.openDropdown = false;
    }
  }

  setOtherOptionText(text: string) {
    if (this.multiple) {
      this.selectedKeys = this.selectedKeys.filter(key => this.dataArray?.includes(key));
      if (text && !this.selectedKeys.includes(text)) {
        this.selectedKeys.push(text);
      }
      this.optionEmitter.emit(this.selectedKeys);
    } else {
      this.optionEmitter.emit(text);
    }
  }

  clearSelection(event: Event) {
    event.stopPropagation();
    this.selectedKeys = [];
    this.optionEmitter.emit([]);
    this.openDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Verifica si el clic ocurrió dentro del dropdown usando el id único
    const element = document.getElementById(`${this.uniqueId}`);

    if (element && !element.contains(targetElement)) {
      this.openDropdown = false;
    }

  }
}
